var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M5.667 11.083h6.666A3.417 3.417 0 0 1 15.75 14.5 1.75 1.75 0 0 1 14 16.25H4a1.75 1.75 0 0 1-1.75-1.75 3.417 3.417 0 0 1 3.417-3.417ZM9 2.75a2.584 2.584 0 1 1 0 5.169A2.584 2.584 0 0 1 9 2.75Z"
  })));
};
export default SvgInfo;